//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format } from "date-fns";

export default {
  name: "SearchResults",
	props: {
		results: Array,
		reloading: Boolean,
		isReloading: Boolean,
	},
	components: {},
	methods: {
		formatDateDisplay(date) {
			return format(new Date(date), "dd MMM yyyy");
		},
		formatDateAttr(date) {
			return format(new Date(date), "yyyy-MM-dd");
		},
	},
};
